var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-warp" }, [
    _c("div", { staticClass: "pc-header" }, [
      _c(
        "div",
        {
          staticClass: "header",
          class: "" + (this.$route.meta.background ? "header-background" : "")
        },
        [
          _c("div", { staticClass: "warp" }, [
            _c("div", { staticClass: "header-flex-box" }, [
              _c("div", { staticClass: "topLeftBox" }, [
                _c("div", { staticClass: "logo" }, [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", cursor: "pointer" },
                      on: { click: _vm.clear }
                    },
                    [
                      _c("img", {
                        attrs: {
                          height: "67px",
                          src: require("@/assets/images/cereshop/home/main_logo" +
                            (this.$route.meta.background ? "_white" : "") +
                            ".png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "147px",
                            height: "67px",
                            "line-height": "67px",
                            "margin-left": "10px"
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              src: require("@/assets/images/b2b_logo" +
                                (this.$route.meta.background ? "_white" : "") +
                                ".svg"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                this.$route.name === "productDetail"
                  ? _c(
                      "div",
                      {
                        staticClass: "shopInfo cur-poi",
                        staticStyle: { display: "none" },
                        on: { click: _vm.toStore }
                      },
                      [
                        _c("div", { staticClass: "shopData" }, [
                          _c("div", { staticClass: "shopName" }, [
                            _vm._v(_vm._s(_vm.collectData.shopName))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "shopType" }, [
                            _c("span", [
                              _vm._v(
                                "商品种类：" +
                                  _vm._s(_vm.collectData.classifyNumber)
                              )
                            ]),
                            _c("span", [
                              _vm._v(
                                "已售：" + _vm._s(_vm.collectData.number) + "件"
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { width: "10%" } }),
              _vm._v(" "),
              _c("div", { staticClass: "search-box" }, [
                _c("div", { staticClass: "search" }, [
                  _c(
                    "div",
                    { staticClass: "searchSelect" },
                    [
                      _c(
                        "el-dropdown",
                        {
                          attrs: { trigger: "click" },
                          on: { command: _vm.searchCommand }
                        },
                        [
                          _c("span", { staticClass: "el-dropdown-link" }, [
                            _vm._v(
                              _vm._s(_vm.searchVal) + "\n                    "
                            ),
                            _c("i", {
                              staticClass:
                                "el-icon-arrow-down cur-poi el-icon--right"
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "商品" } },
                                [_vm._v("商品")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "店铺" } },
                                [_vm._v("店铺")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "searchRight" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.keyword,
                          expression: "keyword"
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder:
                          _vm.searchVal == "商品"
                            ? "请输入搜索商品"
                            : "请输入搜索店铺"
                      },
                      domProps: { value: _vm.keyword },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.searchPro.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.keyword = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  this.$route.meta.background
                    ? _c(
                        "span",
                        {
                          staticClass: "btn cur-poi",
                          staticStyle: {
                            background: "#f77b0b63",
                            color: "#f77b0b"
                          },
                          on: { click: _vm.searchPro }
                        },
                        [_vm._v("搜索")]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "btn cur-poi",
                          on: { click: _vm.searchPro }
                        },
                        [_vm._v("搜索")]
                      )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "myCart", on: { click: _vm.goToShopCart } },
                [
                  _c("span", { staticClass: "icon-The-shopping-cart" }, [
                    _vm.isShowNum && _vm.cartNumber !== 0
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.cartNumber) +
                              "\n              "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v("\n            我的采购单\n          ")
                ]
              )
            ]),
            _vm._v(" "),
            this.$route.meta.menuVisible
              ? _c("div", { staticClass: "menu" }, [
                  _c(
                    "div",
                    {
                      staticClass: "menu-flag",
                      on: {
                        mouseleave: function($event) {
                          _vm.showClassify = false
                        },
                        mouseenter: function($event) {
                          _vm.$route.name !== "index"
                            ? (_vm.showClassify = true)
                            : null
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("a-icon", { attrs: { type: "menu" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("商品分类")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "el-icon-arrow-right",
                        class: "" + (_vm.showClassify ? "turnDown" : "")
                      }),
                      _vm._v(" "),
                      _vm.showClassify == true
                        ? _c(
                            "div",
                            {
                              staticClass: "classify-outer",
                              on: {
                                mouseleave: function($event) {
                                  _vm.showClassify = false
                                },
                                mouseenter: function($event) {
                                  _vm.showClassify = true
                                }
                              }
                            },
                            [
                              _c("cere-classification", {
                                attrs: {
                                  componentContent: _vm.componentContent
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.componentContent.labelList, function(
                      item,
                      index
                    ) {
                      return _c("li", { key: index }, [
                        _c(
                          "a",
                          {
                            class: { active: _vm.isActive(item.name) },
                            on: {
                              click: function($event) {
                                return _vm.jumpLink(item.linkObj)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ])
                    }),
                    0
                  )
                ])
              : _c("div", { staticStyle: { height: "34px" } })
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-add677c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-add677c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/cereshop/pc/header.vue
// module id = null
// module chunks = 